import type { User } from '@takeshape/schema';
import { updateUser } from 'app/auth/actions';
import { getUser } from 'app/auth/selectors';
import type { AuthSlice } from 'app/auth/types';
import type { ProjectSlice } from 'app/project';
import { getCurrentProjectId } from 'app/project/selectors';
import { trackEvent } from 'app/user-tracking/actions';
import { connect } from 'react-redux';
import Help from './help';

type HelpStateProps = {
  projectId: string;
  user: User | null;
};

export function mapStateToProps(state: ProjectSlice & AuthSlice): HelpStateProps {
  const projectId = getCurrentProjectId(state);
  const user = getUser(state).data;
  return { projectId, user };
}

/** Provides a menu of resources to help TakeShape users understand the application.
 *  It loads the current user and project ID from the global store.
 *  It also determines when to show a `<Welcome Tour>` component that introduces new
 *  users to the fundamental capabilities and use cases of TakeShape.
 */
export default connect(mapStateToProps, {
  trackEvent,
  updateUser
})(Help);
